<app-auftrag *ngIf="auftrag$ | async as auftrag" [auftrag]="auftrag"></app-auftrag>
